import ConfigureTransactionReport from "./ConfigureTransactionReport";

export default ConfigureTransactionReport;
